
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"28","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"stroke":"#E60000","stroke-width":"1.875","stroke-linecap":"round","stroke-linejoin":"round","d":"M14.5 26.75L1.75 14 14.5 1.25M1.75 14h28.5"}}),_c('path',{attrs:{"d":"M34 32V-4H-2v36z"}})])])
          )
        }
      }
    